// Category mapping between Tabitto and Mekke
export {
  mapTabittoToMekkeCategory,
  mapMekkeToTabittoCategory,
  type TabittoSpotCategory,
} from "./categoryMapping";

// Geolocation utilities
export { calculateDistanceKm, formatDistance, isWithinRadius } from "./geo";

export function formatDate(date: Date, locale = "ja-JP"): string {
  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(date);
}

export function formatDateTime(date: Date, locale = "ja-JP"): string {
  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function generateId(): string {
  return crypto.randomUUID();
}

/**
 * Calculate trip status based on dates
 * - planning: start date is in the future or dates are not set
 * - confirmed: between start date and end date (trip is ongoing)
 * - completed: end date is in the past
 */
export function computeTripStatus(
  startDate: Date | string | null,
  endDate: Date | string | null
): "planning" | "confirmed" | "completed" {
  // If dates are not set, return planning
  if (!startDate || !endDate) {
    return "planning";
  }

  const now = new Date();
  now.setHours(0, 0, 0, 0); // Compare dates only, not times

  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);

  const end = new Date(endDate);
  end.setHours(0, 0, 0, 0);

  if (now < start) {
    return "planning";
  } else if (now > end) {
    return "completed";
  } else {
    return "confirmed";
  }
}
